import React, { FC, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

import { HelpIconVariant } from '../../../../../../assets/icons/help-icon';
import { HelpIcon } from '../../../../../../assets/icons/index';

type TableHeaderItemProps = {
  className?: string;
  showTooltip?: boolean;
  text: ReactNode | string;
  variant?: 'dark' | 'light';
};
export const TableHeaderItem: FC<TableHeaderItemProps> = ({
  showTooltip = false,
  text,
  variant = 'light',
  className,
}) => {
  return (
    <div
      className={twMerge(
        'border-#F2F2F2 flex items-center gap-2 border-b-[1px] bg-gray-50 px-4 py-3',
        className,
      )}
    >
      <span
        className={twMerge(
          'whitespace-nowrap font-medium',
          variant === 'light' ? 'text-label-md text-[#172335]' : 'text-label-md text-black',
        )}
      >
        {text}
      </span>
      {showTooltip && <HelpIcon variant={HelpIconVariant.EXERCISE} />}
    </div>
  );
};
